// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const XAxisTopIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="XAxisTopIcon" ref={forwardedRef} {...props}>
      <path d="M17 4.5H3V3.75a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1z" />
      <path d="M4.5 6.251v1.5H3v-1.5z" />
      <path d="M4.5 10.75v-1.5H3v1.5z" />
      <path d="M4.5 12.5V14H3v-1.5z" />
      <path d="M4.5 17v-1.5H3V17z" />
      <path d="M17 6.251v1.5h-1.5v-1.5z" />
      <path d="M17 10.75v-1.5h-1.5v1.5z" />
      <path d="M17 12.5V14h-1.5v-1.5z" />
      <path d="M17 17v-1.5h-1.5V17z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const XAxisTopIcon = /* @__PURE__ */ Object.assign(
  XAxisTopIconComponent,
  { displayName: 'XAxisTopIcon' },
);
